module.exports = "/images/6baadf4-reset_password.png";